import instance from '@/plugins/axios'
import type { VehicleDTO } from '@/modules/reservations/models/vehicle'
import type { ResponseResult } from '@/core/models/api-responses'

async function getAll(queryString = ''): Promise<ResponseResult<VehicleDTO[]>> {
    const url = queryString ? `/Vehicles?${queryString}` : '/Vehicles'
    const res = await instance.get<ResponseResult<VehicleDTO[]>>(url)
    return res.data
}

async function getById(id: string): Promise<ResponseResult<VehicleDTO>> {
    const res = await instance.get<ResponseResult<VehicleDTO>>(`/Vehicles/${id}`)
    return res.data
}


export default {
    getAll,
    getById,
}
